import * as React from 'react';
import {Component, CSSProperties, ReactNode} from 'react';

import ArticleNewsListStore from './store';
import ArticleNewsList from '../component';

interface IComponentProps {
  className?: string;
  style?: CSSProperties;
}

interface IComponentInjectedProps extends IComponentProps {
  articleNewsListStore: ArticleNewsListStore;
  exposurePromise: Promise<any>;
}

interface IComponentState {
}

export default class Container extends Component<IComponentProps, IComponentState> {
  constructor(props) {
    super(props);
    this.state = {};
    [].forEach((actionName: string) => {
      this[actionName] = this[actionName].bind(this);
    });
  }

  public get injected(): IComponentInjectedProps {
    return this.props as IComponentInjectedProps;
  }

  public render(): ReactNode {
    const articleNewsListStore: ArticleNewsListStore = this.injected.articleNewsListStore;
    return (
      <ArticleNewsList className={this.props.className} style={this.props.style}
                       isLoading={articleNewsListStore.isLoading}
                       isShowLoadMoreComponent={articleNewsListStore.isShowLoadMoreComponent}
                       newsList={articleNewsListStore.newsList}
                       pageSize={articleNewsListStore.pageSize}
                       currentPage={articleNewsListStore.currentPage}
                       getNewsList={articleNewsListStore.getNewsList}
                       hasMore={articleNewsListStore.hasMore}
                       onLoadMore={articleNewsListStore.uiLoadMore}
                       onShowNewsList={articleNewsListStore.logShowNewsList}
                       onClickNewsItem={articleNewsListStore.onClickNews}
                       exposurePromise={this.injected.exposurePromise}
                       adSlotId={articleNewsListStore.adSlotId}
                       config={articleNewsListStore.config}
                       scriptSrc={articleNewsListStore.scriptSrc}
      />
    );
  }
}
